<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Find Receipt' }}</h2>
      <p>Look up a receipt by its Receipt No or Payment Id, then print or download it.</p>
    </div>
  </div>

  <div class="card search-card">
    <div class="search-row">
      <div class="field key-field">
        <label>Search by</label>
        <p-select [options]="keyOptions" optionLabel="label" optionValue="value"
          [ngModel]="key()" (ngModelChange)="key.set($event); result.set(null)" appendTo="body" />
      </div>
      <div class="field term-field">
        <label>Receipt No / Payment Id</label>
        <input pInputText type="text" [ngModel]="term()" (ngModelChange)="term.set($event)"
          [placeholder]="placeholder" (keyup.enter)="find()" />
      </div>
      <div class="search-actions">
        <p-button label="Find" icon="pi pi-search" [loading]="searching()" (onClick)="find()" />
        <p-button label="Clear" icon="pi pi-times" [outlined]="true" (onClick)="clear()" />
      </div>
    </div>
  </div>

  <div class="card result-card">
    @if (result()) {
      <app-receipt-view [data]="result()" />
    } @else if (searching()) {
      <div class="state"><i class="pi pi-spin pi-spinner"></i><p>Searching…</p></div>
    } @else if (searched()) {
      <div class="state"><i class="pi pi-file-excel"></i><p>No receipt found for that reference.</p></div>
    } @else {
      <div class="state"><i class="pi pi-receipt"></i><p>Enter a receipt no or payment id above to find a receipt.</p></div>
    }
  </div>
</div>
